import React, { useState, useEffect } from 'react';
import styles from './InputModal.module.css';
import { validateAndCleanInput } from '../../utils/security';
import SecureInput from '../SecureInput/SecureInput';

interface InputModalProps {
  open: boolean;
  title?: string;
  label?: string;
  initialValue?: string;
  placeholder?: string;
  confirmText?: string;
  cancelText?: string;
  secondaryText?: string;
  onConfirm: (value?: string) => void;
  onCancel: () => void;
  onSecondary?: () => void;
  showInput?: boolean; // NEW: show input or just confirmation
  message?: string;    // NEW: confirmation message for delete
  danger?: boolean;    // NEW: high-risk destructive action styling
  loading?: boolean;
  loadingText?: string;
  children?: React.ReactNode;
}

const InputModal: React.FC<InputModalProps> = ({
  open,
  title = 'Enter value',
  label = '',
  initialValue = '',
  placeholder = '',
  confirmText = 'OK',
  cancelText = 'Cancel',
  secondaryText,
  onConfirm,
  onCancel,
  onSecondary,
  showInput = true,
  message = '',
  danger = false,
  loading = false,
  loadingText,
  children,
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, open]);

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {title && <h3 className={`${styles.title}${danger ? ` ${styles.titleDanger}` : ''}`}>{title}</h3>}
        {danger && (
          <div className={styles.dangerBanner}>
            ⚠️ This action is irreversible and cannot be undone.
          </div>
        )}
        {showInput ? (
          <SecureInput
            fieldType="text"
            label={label}
            value={value}
            placeholder={placeholder}
            onChange={(newValue) => setValue(newValue)}
            className={styles.input}
          />
        ) : ( message &&
          <p className={styles.message}>{validateAndCleanInput(message)}</p>
        )}
        {children}
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel} disabled={loading}>{cancelText}</button>
          {onSecondary && secondaryText && (
            <button className={styles.discardBtn} onClick={onSecondary} disabled={loading}>{secondaryText}</button>
          )}
          <button
            className={`${styles.confirmBtn}${danger ? ` ${styles.confirmBtnDanger}` : ''}`}
            onClick={() => onConfirm(showInput ? value : undefined)}
            disabled={loading || (showInput && !value.trim())}
          >
            {loading ? (loadingText || confirmText) : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputModal;
